import { render, staticRenderFns } from "./BlackMicropoint.vue?vue&type=template&id=2e2145bc&scoped=true&"
import script from "./BlackMicropoint.vue?vue&type=script&lang=js&"
export * from "./BlackMicropoint.vue?vue&type=script&lang=js&"
import style0 from "./BlackMicropoint.vue?vue&type=style&index=0&id=2e2145bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2145bc",
  null
  
)

export default component.exports